import axios from "axios";
import { useMutation } from "@tanstack/react-query";


/**
 * @description Sends a reset email request for the given user email to Auth0
 * @returns UseMutationResult<string, unknown, any>
 */
export function useResetPasswordMutation() {
  return useMutation(
    async (userEmail: string) => {
      const response = await resetPassword(userEmail);
      if (response.status !== 200) {
        throw new Error("Error sending reset password email");
      }
      return response.data;
    },
    {
      mutationKey: ["resetPassword"],
      onError: (error) => {
        console.error(error);
      }
    }
  );
}

export const resetPassword = async (email: string) => {
  return await axios.post(
    import.meta.env.VITE_ACTIVATE_BACKEND_API +
    "/api/usermanagement/resetpassword/" +
    encodeURIComponent(email)
  );
};
